<template>
    <!-- // 订单管理 - 购买订单管理 - 票券信息修改 -->
    <content-view>
        <div class="amend-ticket">
            <!-- 权限名称-adminOrderRenewalTicket -->
            <a-button type="primary" @click="openTicketRenewal" :disabled="!(getBtnByAuth('adminOrderRenewalTicket') && ticketData.showState === 'OVERDUE' && ticketData.isUseFull && ticketData.remainNum !== 0)">过期续期</a-button>
            <!-- <a-button type="primary" @click="visibleUpgrade = true" :disabled="!(ticketData.isUseFull && ticketData.remainNum !== 0 && ticketData.showState !== 'OVERDUE' && ticketData.showState !== 'USED' && (ticketData.sourceCode === 'Buy' || ticketData.sourceCode === 'GiveActivityBuy' || ticketData.sourceCode === 'GoodsGrant' || ticketData.sourceCode === 'GiveActivityGoodsGrant') && (!ticketData.isGift || !ticketData.isBonus))">票券升级</a-button> -->

            <a-button type="primary" @click="visibleRedate = true" :disabled="!(ticketData.isUseFull && ticketData.showState !== 'USED' && ticketData.showState !== 'OVERDUE' && ticketData.remainNum !== 0)">有效期重置</a-button>

            <a-button type="primary" @click="visiblePhone = true" :disabled="!(ticketData.isUseFull && ticketData.showState !== 'OVERDUE' && ticketData.showState !== 'USED' && ticketData.remainNum !== 0 && ticketData.isCanOwnerChange)">持有者更改</a-button>

            <!-- <a-button type="primary" @click="visibleGive = true" :disabled="!(ticketData.isUseFull && ticketData.showState !== 'OVERDUE' && ticketData.type == 2)">次数赠送</a-button> -->

            <a-button type="primary" @click="unfreezeTicket" v-if="ticketData.isFrozen || ticketData.frozenStartTime">票券解冻</a-button>
            <a-button type="primary" :disabled="!(ticketData.isUseFull && ticketData.remainNum !== 0 && ticketData.showState !== 'OVERDUE' && ticketData.showState !== 'USED')" @click="freezeTicket" v-else >票券冻结</a-button>

            <template v-if="getBtnByAuth('ticketCourseState')">
                <a-button type="primary" @click="forbidden(ticketData.userTicketNo,false)" v-if="ticketData.isForbidden">取消禁用</a-button>
                <a-button type="primary" @click="forbidden(ticketData.userTicketNo, true)" v-else :disabled="!(ticketData.isUseFull && ticketData.showState !== 'USED' && ticketData.remainNum !== 0)">禁用</a-button>
            </template>
            <template v-else>
                <a-button type="primary" :disabled="true">禁用</a-button>
            </template>

            <a-button type="primary" @click="ticketRefund" :disabled="!((ticketData.sourceCode === 'Buy' || ticketData.sourceCode === 'GiveActivityBuy' || ticketData.sourceCode === 'GoodsGrant' || ticketData.sourceCode === 'GiveActivityGoodsGrant') && (!ticketData.isGift || !ticketData.isBonus) && ticketData.isUseFull && ticketData.remainNum !== 0 && ticketData.showState !== 'USED' && ticketData.platform !== '积分小程序') || ticketData.platform == '第三方购买'">退款</a-button>

            <member-order-refund ref="refund" @changeVisibleRefund="changeVisibleRefund" :ticketData="ticketData" :visibleRefund="visibleRefund"></member-order-refund>
            <member-order-upgrade ref="upgrade" @changeVisibleUpgrade="changeVisibleUpgrade" :ticketData="ticketData" :visibleUpgrade="visibleUpgrade"></member-order-upgrade>
            <member-order-redate ref="redate" @changeVisibleRedate="changeVisibleRedate" :ticketData="ticketData" :visibleRedate="visibleRedate"></member-order-redate>
            <member-order-phone ref="phone" @changeVisiblePhone="changeVisiblePhone" :ticketData="ticketData" :visiblePhone="visiblePhone"></member-order-phone>
            <member-order-give ref="give" @changeVisibleGive="changeVisibleGive" :ticketData="ticketData" :visibleGive="visibleGive"></member-order-give>
            <member-order-freeze ref="freeze" @changeVisibleFreeze="changeVisibleFreeze" @reloadData="getDetail" :ticketData="ticketData" ></member-order-freeze>
            <div class="ticket-main">
                <member-card :ticketData="ticketData"></member-card>
            </div>
        </div>
        <div class="amend-detail">
            <a-tabs :defaultActiveKey="0" @change="changeTabs" size="small" :animated="false" :tabBarStyle="{height: '50px', borderBottom: '0px', padding: '0px 12px'}">
                <template slot="tabBarExtraContent">
                    <a-radio-group v-if="isGived" v-model="isOriginal" button-style="solid" @change="isOriginalChange">
                        <a-radio-button :value="0">
                            当前持有人
                        </a-radio-button>
                        <a-radio-button :value="1">
                            原持有人
                        </a-radio-button>
                    </a-radio-group>
                </template>
                <a-tab-pane tab="操作记录" :key="1" :forceRender="true">
                    <div>
                        <a-table bordered :dataSource="dataSource2" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="index" slot-scope="a, row, index">{{index+1}}</span>
                            <span slot="amount" slot-scope="amount">{{amount === 0 ? 0 : (amount || "-")}}</span>
                            <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane tab="核销记录" :key="3" :forceRender="true">
                    <div>
                        <a-table style="word-break:break-all;" :scroll="{y:400}" :pagination="pagination" @change="changePage" bordered :dataSource="dataSource1" :columns="columnsVerify" :rowKey="(record,index) => index">
                            <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                            <span slot="isFlag" slot-scope="isFlag">{{['否','是'][Number(isFlag)]}}</span>
                            <span slot="orderNum" slot-scope="orderNum, row">{{row.reserveNo ? row.verifyNum : "-"}}</span>
                            <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
                            <span slot="action" slot-scope="text, row">
                                <span v-if="getBtnByAuth('verifyReservationRecord')">
                                    <a class="text-primary" v-if="row.reserveNo" @click="openModal(row, 3)">预约记录</a>
                                    <span v-else class="text-disabled">预约记录</span>
                                </span>
                                <a-divider v-if="getBtnByAuth('verifyReservationRecord') && getBtnByAuth('ticketVerifyReturn')"/>
                                <span v-if="getBtnByAuth('ticketVerifyReturn')">
                                    <a v-if="row.returnNum < row.verifyNum" class="text-primary" @click="openModal(row, 2)">次数退还</a>
                                    <span v-else class="text-disabled">次数退还</span>
                                </span>
                            </span>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane tab="预约记录" :key="2" :forceRender="true">
                    <div>
                        <a-table bordered :dataSource="dataSource" :columns="columnsOrder" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="state" slot-scope="state,row">{{['','已预约','预约取消','已核销','预约过期','次数退还'+row.returnNum+'次'][state]}}</span>
                            <span slot="orderNum" slot-scope="orderNum">{{orderNum || 1}}</span>
                            <span slot="buyShopName" slot-scope="buyShopName">{{buyShopName || "-"}}</span>]
                            <span slot="reserveShopName" slot-scope="reserveShopName">{{reserveShopName || "-"}}</span>
                            <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                            <span slot="reserveDate" slot-scope="reserveDate, row">{{row.periodStartTime | dateSplit}} ~ {{row.periodEndTime | dateSplit}}</span>
                            <span slot="reservePeriod" slot-scope="key, row">{{row.periodStartTime.substring(11, 16)}}~{{row.periodEndTime.substring(11, 16)}}</span>
                            <span v-if="getBtnByAuth('ticketReservationCancel')" slot="action" slot-scope="text, row">
                                <a @click="openModal(row, 1)" v-if="row.state == 1 || row.state == 4" class="text-primary">预约取消</a>
                                <a v-else class="text-disabled">预约取消</a>
                            </span>
                        </a-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <a-modal
        centered
        title="取消预约"
        :visible="visibleCancel"
        @cancel="closeModal"
        @ok="cancelReserve"
        :width="500">
            <a-form :form="cancelForm">
                <remark :labelSpan="5" :wrapperSpan="18" operateCode="CancelReserve" ></remark>
            </a-form>
        </a-modal>
        <a-modal
            title="预约记录"
            :visible="visibleOrderRecord"
            width="1000px"
            @cancel="visibleOrderRecord = false"
            :footer="false">
            <a-table bordered :dataSource="orderList" :columns="columnsRecord" :pagination="false" :rowKey="(record, index) => index">
                <span slot="index" slot-scope="a, row, index">{{index + 1 }}</span>
                <span slot="orderNum" slot-scope="orderNum">1</span>
                <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
            </a-table>
        </a-modal>
        <count-refund @closeModalCountRefund="closeModalCountRefund" @closeModal="closeModal" :id="currentRow.id" :maxNum="currentRow.verifyNum - currentRow.returnNum" :visibleCountRefund="visibleReturn" />
        <member-order-forbidden @changeVisibleForbbiden="changeVisibleForbbiden" ref="forbiddenModal" @ok="getDetail"></member-order-forbidden>
        <ticket-renewal @callback="this.getDetail" ref="ticketRenewal"></ticket-renewal>
    </content-view>
</template>

<script type="text/javascript">
    import memberCard from "@/components/modules/order/member-card.component";
    import memberOrderRefund from "@/components/modules/order/member-order-refund.component";
    import memberOrderUpgrade from "@/components/modules/order/member-order-upgrade.component";
    import memberOrderRedate from "@/components/modules/order/member-order-redate.component";
    import memberOrderPhone from "@/components/modules/order/member-order-phone.component";
    import memberOrderGive from "@/components/modules/order/member-order-give.component";
    import memberOrderFreeze from "@/components/modules/order/member-order-freeze.component";
    import memberOrderForbidden from '@/components/modules/order/member-order-forbidden.component';
    import countRefund from '@/components/modules/order/count-refund.component';
    import remark from '@/components/modules/platform/remark.component';
    import ticketRenewal from '@/components/modules/order/ticket-renewal.component';

    const columnsOrder = [
        {
            title: "用户票券id",
            dataIndex: "reserveObject"
        },
        {
            title: "预约人",
            dataIndex: "phone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "购买途径",
            dataIndex: "platform",
            scopedSlots: { customRender: "platform" }
        },
        {
            title: "预约使用门店",
            dataIndex: "reserveShopName",
            scopedSlots: { customRender: "reserveShopName" }
        },
        {
            title: "预约状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
        {
            title: "预约使用日期",
            dataIndex: "reserveDate",
            scopedSlots: { customRender: "reserveDate" }
        },
        {
            title: "预约场次",
            dataIndex: "reservePeriod",
            scopedSlots: { customRender: "reservePeriod" }
        },
        {
            title: "预约下单时间",
            dataIndex: "reserveTime",
            scopedSlots: { customRender: "reserveTime" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ]
    const columnsVerify = [
        {
            title: "用户票券id",
            dataIndex: "verifyObject"
        },
        {
            title: "会员手机号",
            dataIndex: "phone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "核销人",
            dataIndex: "useUserPhone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "购买途径",
            dataIndex: "platform",
            scopedSlots: { customRender: "platform" }
        },
        {
            title: "核销门店",
            dataIndex: "verifyShopName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "核销票台",
            dataIndex: "verifyPlatformName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
        {
            title: "核销次数",
            dataIndex: "verifyNum",
            scopedSlots: { customRender: "verifyNum" }
        },
        {
            title: "退还次数",
            dataIndex: "returnNum",
            scopedSlots: { customRender: "returnNum" }
        },
        {
            title: "是否强制核销",
            dataIndex: "isForce",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "是否购买门店核销",
            dataIndex: "isBuyShopVerify",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "是否适用门店核销",
            dataIndex: "isSuitShopVerify",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "核销时间",
            dataIndex: "verifyTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作人",
            dataIndex: "cashier",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columnsRecord = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "预约使用时间",
            dataIndex: "reserveDate",
            scopedSlots: { customRender: "reserveDate" }
        },
        {
            title: "预约场次",
            dataIndex: "reservePeriod",
            scopedSlots: { customRender: "reservePeriod" }
        },
        {
            title: "预约门店",
            dataIndex: "reserveShopName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
    ]
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "操作时间",
            dataIndex: "operateTime",
            width: 200
        },
        {
            title: "操作动作",
            dataIndex: "operateName",
            width: 150
        },
        {
            title: "操作内容",
            dataIndex: "operateDetail",
            scopedSlots: { customRender: "empty" },
        },
        {
            title: "备注类型",
            dataIndex: "remarkCategoryName",
            scopedSlots: { customRender: "empty" },
            width: 100
        },
        {
            title: "备注",
            dataIndex: "remark",
            scopedSlots: { customRender: "empty" },
            width: 100
        },
        {
            title: "操作人",
            dataIndex: "operator",
            scopedSlots: { customRender: "empty" },
            width: 100
        }
    ]
    export default {
        name: "amendTicket",
        components: {
            memberCard,
            memberOrderRefund,
            memberOrderUpgrade,
            memberOrderRedate,
            memberOrderPhone,
            memberOrderGive,
            memberOrderFreeze,
            memberOrderForbidden,
            countRefund,
            remark,
            ticketRenewal
        },
        filters: {
            dateSplit(val) {
                if (!val) return "";
                return val.substring(0, 10);
            }
        },
        data() {
            return {
                columns,
                columnsOrder,
                columnsVerify,
                columnsRecord,
                visibleRefund: false,
                visibleUpgrade: false,
                visibleRedate: false,
                visiblePhone: false,
                visibleGive: false,
                ticketData: {},
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                dataSource: [],
                dataSource1: [],
                dataSource2: [],
                orderList: [],
                visibleCancel: false,
                visibleReturn: false,
                visibleOrderRecord: false,
                currentRow: {},
                // orderDetail: {},
                tabActions: 1,
                isOriginal: 0,
                isGived: false
            };
        },
        watch: {
            '$route.query.id' (val) {
                this.getDetail();
            }
        },
        methods: {
            changeTabs(tab) {
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.tabActions = tab;
                if (tab == 1) {
                    this.getUsingList();
                } else if (tab == 2) {
                    this.getList();
                }  else if (tab == 3) {
                    this.getListVerify();
                }
            },
            openModal(row, type) {
                this.currentRow = row
                if (type == 1) {
                    this.cancelForm.resetFields();
                    this.visibleCancel = true;
                } else if (type == 2) {
                    this.visibleReturn = true
                } else if (type == 3) {
                    this.visibleOrderRecord = true
                    this.getOrderList();
                }
            },
            closeModal() {
                this.getDetail()
                this.visibleReturn = false;
                this.visibleCancel = false;
                setTimeout(() => {
                    this.getListVerify();
                }, 500);
            },
            closeModalCountRefund() {
                this.visibleReturn = false
            },
            // 获取列表
            getUsingList() {
                this.$api.order.opRecord({
                    body: {
                        isOriginal: Boolean(this.isOriginal),
                        userTicketNo: this.ticketData.userTicketNo,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                    }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource2 = res.list || [];
                });
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                if (this.tabActions == 1) {
                    this.getUsingList();
                } else if (this.tabActions == 2) {
                    this.getList();
                }  else if (this.tabActions == 3) {
                    this.getListVerify();
                }
            },
            getOrderList() {
                if (!this.currentRow.reserveObject && !this.currentRow.verifyObject) return;
                let verifyNo = this.currentRow.id;
                this.loading = true;
                this.$api.order.getVerifyReserveList({
                    body: {
                        pageNum: 1,
                        pageSize: 9999,
                        verifyId: verifyNo,
                    }
                }).then(res => {
                    this.loading = false;
                    this.orderList = res.list;
                }).catch(err => {
                    this.loading = false;
                })
            },
            // 获取预约列表
            getList() {
                this.$api.order.getTicketOrderList({
                    query: {
                        isOriginal: Boolean(this.isOriginal),
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        reserveObject: this.ticketData.userTicketNo,
                    }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                }).catch(err => {
                })
            },
            getListVerify() {
                this.$api.order.getTicketVerifyList({
                    query: {
                        isOriginal: Boolean(this.isOriginal),
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        verifyObject: this.ticketData.userTicketNo,
                    },
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource1 = res.list;
                }).catch(err => {
                })
            },
            // 取消预约
            cancelReserve() {
                this.cancelForm.validateFields((err, values) => {
                    if (err) return;
                    this.$api.order.cancelReserve({
                        body: {reserveId: this.currentRow.id, ...values}
                    })
                    .then(res => {
                        this.visibleCancel = false;
                        this.$message.success('操作成功',2)
                        setTimeout(() => {
                            this.getList();
                        }, 500);
                    })
                })

            },
            // 获取基础票券详情
            getDetail() {
                this.$api.order
                .detailUserTicket({
                    params: {userTicketNo: this.$route.query.id}
                })
                .then(res => {
                    this.isGived = res.userTicketNo !== res.originalUserTicketNo;
                    res.validStartTime = res.validStartTime && res.validStartTime.split(" ")[0];
                    res.validEndTime = res.validEndTime && res.validEndTime.split(" ")[0];
                    let {showState, isFrozen , isInvalid , isForbidden, isLocked} = res;
                    res.isUseFull = Boolean(!isFrozen  && !isInvalid  && !isForbidden && !isLocked);
                    res.isActivity = res.giveGrantId && !res.isGift && !res.isBonus;
                    res.isCanOwnerChange = Boolean(res.ownerChangeTimes === -1 || (res.ownerChangeTimes - res.alreadyOwnerChangeTimes > 0));
                    this.ticketData = res;
                    // this.getList();
                    // this.getListVerify();
                    this.getUsingList();
                });
            },
            // 获取订单列表
            // getOrder() {
            //     this.$api.order.orderSearch({
            //         query: {
            //             pageNum: 1,
            //             pageSize: 1,
            //             goodsType: "TICKET",
            //             tradeNoOnly: true,
            //             tradeNo: this.$route.params.orderId,
            //         },
            //     }).then(res => {
            //         this.orderDetail = res.list[0];
            //     })
            // },
            // 打开退款详情弹框
            changeVisibleRefund(val) {
                this.visibleRefund = val;
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            // 打开升级详情弹框
            changeVisibleUpgrade(val) {
                this.visibleUpgrade = val;
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            // 打开有效期重置详情弹框
            changeVisibleRedate(val) {
                this.visibleRedate = val
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            // 打开持有者更改详情弹框
            changeVisiblePhone(val) {
                this.visiblePhone = val
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            changeVisibleFreeze(val) {
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            changeVisibleForbbiden(val) {
                setTimeout(() => {
                    this.getDetail();
                },300);
            },

            // 打开次数赠送详情弹框
            changeVisibleGive(val) {
                this.visibleGive = val
                setTimeout(() => {
                    this.getDetail();
                },300);
            },
            ticketRefund() {
                // if (this.orderDetail.tradeState == "退款中" && !this.ticketData.isLocked) {
                //     this.$message.warn('交易单处于"退款中"，无法继续发起退款');
                //     return
                // }
                if (this.$moment().day() == 1 || (this.$moment().format('H') < 10 || this.$moment().format('H') >= 23)) {
                    this.$message.warn('当前银联系统收款账户清算中，暂不支持退款。每周一全天和其他日期的23点-次日10点管理后台和小程序都不支持退款。');
                    return
                };
                this.visibleRefund = true;
            },
            /**
             * @freezeTicket 票券冻结
             */
            freezeTicket() {
                if (this.ticketData.frozenStartTime && this.ticketData.frozenEndTime) {
                    this.$refs.freeze.visible = true;
                    this.$refs.freeze.isFreeze = false;
                    this.$refs.freeze.ticketFrozenInfo();
                } else {
                    this.$refs.freeze.visible = true;
                    this.$refs.freeze.isFreeze = true;
                }
            },
            /**
             * @unfreezeTicket 票券解冻
             */
            unfreezeTicket() {
                this.$refs.freeze.visible = true;
                this.$refs.freeze.isFreeze = false;
                this.$refs.freeze.ticketFrozenInfo();
            },
            /**
             * @forbidden 禁用/解禁
             */
            forbidden(userTicketId, forbidden) {
                this.$refs.forbiddenModal.show(userTicketId, forbidden);
            },
            /**
             * @openTicketRenewal 票券过期延期
             */
            openTicketRenewal() {
                this.$refs.ticketRenewal.open(this.ticketData.userTicketNo);
            },
            /**
             * @isOriginalChange 是否当前持有人
             */
            isOriginalChange() {
                if (this.tabActions == 1) {
                    this.getUsingList();
                } else if (this.tabActions == 2) {
                    this.getList();
                }  else if (this.tabActions == 3) {
                    this.getListVerify();
                }
            },
        },
        created() {
            this.cancelForm = this.$form.createForm(this);
        },
        mounted() {
            this.getDetail()
        },
    };
</script>
<style lang="scss">
    .amend-detail {
        margin-top: 24px;
        background: #FFF;
        padding: 24px;
        border-radius: 2px;
    }
    .amend-ticket {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        .ticket-main {
            margin-top: 20px;
            >p {
                span {
                    font-family: "PingFangSC-Medium";
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .ticket-sub {
                margin-top: 20px;
                border-top: 1px solid rgba(0, 0, 0, 0.09);
                color: rgba(0, 0, 0, 0.65);
            .ant-row {
                line-height: 50px;
            }
            .title {
                color: rgba(0, 0, 0, 0.85);
            }
            }
        }
    }
</style>
